export default () => (
  <svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.89889 0.656854C8.7898 0.656854 9.23596 1.734 8.606 2.36396L5.36336 5.6066C4.97283 5.99713 4.33967 5.99713 3.94914 5.6066L0.706503 2.36396C0.0765379 1.734 0.522705 0.656854 1.41361 0.656854L7.89889 0.656854Z"
      fill="#001335"
    />
  </svg>
)
